import { type InstrumentWithMetadata } from "helpers/types/instruments/metadata"

export function getDownloadDataFileName(instrumentMetadata: InstrumentWithMetadata, isIntraday: boolean, latestPriceTimestamp: string | null) {
  const safeTimestamp = latestPriceTimestamp ? latestPriceTimestamp.replace(/:/g, "-") : ""
  return `Dashboard - ${instrumentMetadata?.name || instrumentMetadata?.id}${isIntraday ? "-Intraday" : ""}${safeTimestamp ? `-${safeTimestamp}` : ""}`
}

export const DOWNLOAD_SHEET_ORDER = {
  assets: 0,
  factors: 1,
  kpi: 2,
}
